export const formatDate = (date: string) => {
  const isoDate = new Date(date);

  return (
    `${isoDate.getDate() < 10 ? ('0' + isoDate.getDate()) : isoDate.getDate()}` +
    '/' +
    `${(isoDate.getMonth() + 1) < 10 ? ('0' + (isoDate.getMonth() + 1)) : (isoDate.getMonth() + 1)}` +
    '/' +
    isoDate.getFullYear()
  );
};

export const getCurrentDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm: any = today.getMonth() + 1;
  let dd: any = today.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;

  const formattedToday = dd + '/' + mm + '/' + yyyy;

  return formattedToday;
};

export const formatNumber = (number: string | number) =>
  parseFloat(Number(number).toFixed(2));

export const formatPrice = (number: string | number) =>
  Number(number).toFixed(2);
